var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGrid3X3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20816 -1144)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20816 1144)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20816 1152.067)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20816 1160.133)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20824.066 1144)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20824.066 1152.067)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20824.066 1160.133)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20832.133 1144)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20832.133 1152.067)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20832.133 1160.133)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.933,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.933,
    cy: 2.933,
    r: 2.183,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrid3X3);
export default __webpack_public_path__ + "static/media/icon-grid-3x3.4f468d02441bf5635de8fb0879db0798.svg";
export { ForwardRef as ReactComponent };